import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d0e8c708"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "chart",
  ref: "chart"
};
const _hoisted_2 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("canvas", {
    id: $props.id
  }, null, 8, _hoisted_2)], 512);
}